module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAXElEQVR4AWMYHOCcoNp/cvAgMuA/eQC3ASvunfyPQ4ywAZOv7fnPMC/h/4Sru+Bii+4cBYmBaMIG3Pjw/P+6B2fANAw8/PLm/95n18A0EqBKGCDMIAsPvAHDAwAAUsuKt7S/fYoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/SY.png
// module id = 1272
// module chunks = 0